import React, { useCallback, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { Button, makeStyles, Typography } from '@material-ui/core';
import { I18n } from 'src/translations/i18n';
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        padding: theme.spacing(4)
    },
    message: {
        marginBottom: theme.spacing(2)
    }
}));
// Shown by the route ErrorBoundary in App when a page crashes; navigating to another page resets it.
function RouteErrorFallback({ resetError }) {
    const classes = useStyles();
    const location = useLocation();
    const errorPathname = useRef(location.pathname);
    useEffect(() => {
        if (location.pathname !== errorPathname.current)
            resetError();
    }, [location.pathname, resetError]);
    const reloadPage = useCallback(() => window.location.reload(), []);
    return (React.createElement("div", { className: classes.root },
        React.createElement(Typography, { variant: "h6", className: classes.message }, I18n.t('SomethingWentWrong')),
        React.createElement(Button, { variant: "contained", color: "primary", onClick: reloadPage }, I18n.t('ReloadPage'))));
}
export default RouteErrorFallback;
